/* eslint-disable require-jsdoc */
import React from 'react';
import hasProp from 'hasprop';
import {defaultImg} from '../../utils/defaultImg';
import {isValid} from '../../utils/validate';
import BandSocial from './BandSocial';

const bands = (props) => {
  return (
    <div>
      {hasProp(props, ['bands']) ?
      <div className='hearby-section-thelineup'>

        {isValid(props.bands) ? <h2> The Line Up </h2>: null}

        {
          props.bands.map((item, index) => {
            return (
              <div key={index}>
                <div className="hearby-details-row heda-artist">
                  <div className="hearby-col hearby-col-60">

                    <div className="heda-artist-avatar">
                      {isValid(item.bandGuid) ? <a href={`https://hearby.com/artist-detail/?bandGuid=${item.bandGuid}`} target="_blank" rel='noreferrer'>
                        <img src={item.bandImagePath}
                          onError={(e)=>{
                            e.target.onerror = null;
                            e.target.src=defaultImg();
                          }}></img>
                      </a>: null}
                    </div>

                    <div className="heda-artist-name">
                      {isValid(item.bandGuid) ? <a href={`https://hearby.com/artist-detail/?bandGuid=${item.bandGuid}`} target="_blank" rel='noreferrer'
                        className="heda-artist-name-link">{item.bandName}</a> :
                          null}
                      <div>
                        <BandSocial bandSocial={props} bandIndex={index}/>
                      </div>
                    </div>

                  </div>

                  <div className="hearby-col hearby-col-40">
                    <div className="heda-player">
                      {isValid(item.spotifyId) ?
                        <iframe src={`https://open.spotify.com/embed/artist/${item.spotifyId}`}
                        loading='lazy'
                          height="80"
                          frameBorder="0"
                          allowtransparency="true"
                          allow="encrypted-media">
                        </iframe> : null }
                    </div>
                  </div>

                </div>
              </div>
            );
          },
          )
        }
      </div> :
       null}
      {/* {console.log('Bands.js props.bands', props.bands)} */}
    </div>
  );
};

export default bands;